import { ReactNode } from 'react';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { mainnet } from 'wagmi/chains';
import { coinbaseWallet, injected } from 'wagmi/connectors';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configure wagmi with wallet connectors
// Using injected() instead of metaMask() to avoid SDK issues on mobile Safari
const config = createConfig({
  chains: [mainnet],
  connectors: [
    // Generic injected connector - works with MetaMask, etc.
    injected({
      target: 'metaMask',
    }),
    coinbaseWallet({
      appName: 'MfersArcade',
    }),
    // Phantom wallet - uses injected connector with phantom target
    injected({
      target: {
        id: 'phantom',
        name: 'Phantom',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        provider: () => (window as any).phantom?.ethereum,
      },
    }),
  ],
  transports: {
    [mainnet.id]: http(),
  },
});

const queryClient = new QueryClient();

interface WalletProviderProps {
  children: ReactNode;
}

export function WalletProvider({ children }: WalletProviderProps) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default WalletProvider;
